import { SearchTab } from 'owa-search-types/lib/types/SearchTab';
import { SearchScenarioId } from 'owa-search-store';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import isSharedFolderSearch from 'owa-mail-search-utils/lib/utils/isSharedFolderSearch';
import { getSafeSelectedTableView, getViewFilterForTable } from 'owa-mail-list-store';
import type { SearchTableQuery } from 'owa-mail-list-search';
import { getStore as getMailSearchStore } from 'owa-mail-search';
import { getSelectedNode } from 'owa-mail-folder-forest-store';
import { type FolderForestNodeType } from 'owa-favorites-types';
import type { MailboxInfo } from 'owa-client-types';
import { isSearchPlusChatFeatureEnabled } from 'owa-search/lib/utils/isSearchPlusChatFeatureEnabled';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

export function isSearchPlusChatFeatureEnabledForSearchSession(
    scenarioId?: SearchScenarioId,
    mailboxInfo?: MailboxInfo
): boolean {
    const tableView = getSafeSelectedTableView();
    const tableQuery = tableView?.tableQuery;
    const activeSearchTab: SearchTab | undefined = tableQuery
        ? (tableQuery as SearchTableQuery).searchTab
        : undefined;
    const targetMailboxInfo = mailboxInfo || getModuleContextMailboxInfo();
    const searchProvider = getMailSearchStore().provider;
    const isInitialPersonaFavoriteFolder =
        getSelectedNode().type === 1 && getViewFilterForTable(tableView) == null;

    // This basic check is for things inherent to the mailbox,
    // while the other checks add in search session context
    const isBasicFeatureEnabled = isSearchPlusChatFeatureEnabled(targetMailboxInfo);

    // Don't show SearchPlusChat when a MessageSuggestion (email entity) is selected
    const isMessageSuggestionSelected =
        (tableQuery as SearchTableQuery)?.scenarioType === 'messageSuggestion';

    return (
        isBasicFeatureEnabled &&
        (scenarioId === SearchScenarioId.Mail || scenarioId === undefined) &&
        (activeSearchTab == undefined ||
            activeSearchTab == SearchTab.Mail ||
            activeSearchTab == SearchTab.All) &&
        (isGlobalFeatureEnabled('sea-enableImmersiveSearchForSharedFolders') ||
            !isSharedFolderSearch()) &&
        !isInitialPersonaFavoriteFolder &&
        !isMessageSuggestionSelected &&
        (searchProvider === 'SubstrateSearchV2' || !searchProvider)
    );
}
